/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const noop: () => void = () => undefined;

export const asyncNoop: () => Promise<void> = () =>
  new Promise((resolve) => resolve());
